import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NextcloudFilePreviewComponent } from './components/label/nextcloud-file-preview/nextcloud-file-preview.component';
import { AttachementPreviewComponent } from './components/label/attachement-preview/attachement-preview.component';
import { LocalFilePreviewComponent } from './components/label/local-file-preview/local-file-preview.component';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { NextcloudFolderExplorerComponent } from './components/embedded/nextcloud-folder-explorer/nextcloud-folder-explorer.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FileSizePipe } from './pipes/file-size.pipe';
import { NextcloudPathNavigatorComponent } from './components/embedded/nextcloud-path-navigator/nextcloud-path-navigator.component';
import { OnlyofficeComponent } from './components/embedded/onlyoffice/onlyoffice.component';
import { OnlyofficeDialogComponent } from './components/dialog/onlyoffice-dialog/onlyoffice-dialog.component';
import { NextcloudExplorerComponent } from './components/embedded/nextcloud-explorer/nextcloud-explorer.component';
import { FileListEntryComponent } from './components/embedded/file-list-entry/file-list-entry.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { NextcloudPipe } from './pipes/nextcloud.pipe';
import { MatButtonModule } from '@angular/material/button';
import { SelectFileViewDialogComponent } from './components/dialog/select-file-view-dialog/select-file-view-dialog.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FileTileEntryComponent } from './components/embedded/file-tile-entry/file-tile-entry.component';
import { SharedModule } from '../shared/shared.module';
import { SelectFileDialogComponent } from './components/dialog/select-file-dialog/select-file-dialog.component';
import { FileTypePipe } from './pipes/file-type.pipe';

@NgModule({
  declarations: [
    NextcloudFilePreviewComponent, 
    AttachementPreviewComponent,
    LocalFilePreviewComponent,
    DragAndDropDirective,
    NextcloudFolderExplorerComponent,
    FileSizePipe,
    FileListEntryComponent,
    NextcloudPathNavigatorComponent,
    NextcloudExplorerComponent,
    OnlyofficeDialogComponent,
    OnlyofficeComponent,
    NextcloudPipe,
    SelectFileViewDialogComponent,
    FileTileEntryComponent,
    SelectFileDialogComponent,
    FileTypePipe
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatInputModule,
    FormsModule,
    MatCheckboxModule,
    MatMenuModule,
    MatToolbarModule,
    SharedModule
  ],
  exports: [
    NextcloudFilePreviewComponent,
    AttachementPreviewComponent,
    LocalFilePreviewComponent,
    DragAndDropDirective,
    NextcloudFolderExplorerComponent,
    FileSizePipe,
    FileListEntryComponent,
    NextcloudExplorerComponent,
    NextcloudPipe,
    NextcloudPathNavigatorComponent,
    OnlyofficeDialogComponent,
    OnlyofficeComponent,
    SelectFileViewDialogComponent,
    FileTypePipe
  ]
})
export class NextcloudModule { }
